module.exports = __webpack_public_path__ + "img/kyouzai_junior_high_school_algebra.44b249ee.png";